<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 设备故障分析
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="dataPicker">
                <el-date-picker
                    v-model="value2"
                    type="daterange"
                    align="center"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                ></el-date-picker>
                <el-button type="success" class="btn1">搜索</el-button>
                <el-button type="primary">刷新</el-button>
            </div>
            <div class="lineS" ref="deviceStatusLine"></div>
            <div class="botCharts">
                <div class="leftS" ref="deviceStatusPie"></div>
                <div class="rightS" ref="deviceStatusCat"></div>
            </div>

            <el-button type="primary">导出表格</el-button>

            <el-table class="elTable" :data="tableData" border style="width: 100%">
                <el-table-column prop="date" label="日期" align="center"></el-table-column>
                <el-table-column prop="s1" label="故障" align="center"></el-table-column>
                <el-table-column prop="s2" label="演练" align="center"></el-table-column>
                <el-table-column prop="s3" label="测试" align="center"></el-table-column>
                <el-table-column prop="s4" label="误报" align="center"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
// import { fetchData } from '../../api/index';
import * as echarts from 'echarts';
export default {
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            value1: '',
            value2: '',
            tableData: [
                {
                    date: '2022-08-22',
                    s1: 1,
                    s2: 0,
                    s3: 0,
                    s4: 0
                },
                {
                    date: '2022-08-23',
                    s1: 1,
                    s2: 1,
                    s3: 0,
                    s4: 0
                },
                {
                    date: '2022-08-24',
                    s1: 0,
                    s2: 1,
                    s3: 0,
                    s4: 0
                },
                {
                    date: '2022-08-25',
                    s1: 1,
                    s2: 0,
                    s3: 2,
                    s4: 0
                },
                {
                    date: '2022-08-26',
                    s1: 0,
                    s2: 0,
                    s3: 0,
                    s4: 0
                },
                {
                    date: '2022-08-27',
                    s1: 1,
                    s2: 2,
                    s3: 0,
                    s4: 0
                },
                {
                    date: '2022-08-28',
                    s1: 2,
                    s2: 0,
                    s3: 0,
                    s4: 0
                }
            ]
        };
    },
    mounted() {
        setTimeout(() => {
            // 绘制设备状态折线图
            let myChart = this.$echarts.init(this.$refs.deviceStatusLine);
            myChart.setOption({
                color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
                title: {
                    text: '设备故障分析曲线图'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: ['故障', '演练', '测试', '误报']
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['8-22', '8-23', '8-24', '8-25', '8-26', '8-27', '8-28']
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '故障',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgb(128, 255, 165)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgb(1, 191, 236)'
                                }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: [1, 2, 4, 3, 3, 0, 5]
                    },
                    {
                        name: '演练',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgb(0, 221, 255)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgb(77, 119, 255)'
                                }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: [4, 3, 1, 2, 2, 5, 0]
                    },
                    {
                        name: '测试',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgb(55, 162, 255)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgb(116, 21, 219)'
                                }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: [0, 0, 0, 0, 0, 0, 0]
                    },
                    {
                        name: '误报',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgb(255, 0, 135)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgb(135, 0, 157)'
                                }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: [0, 0, 0, 0, 0, 0, 0]
                    }
                ]
            });

            // 绘制设备状态饼状图
            let pieChart = this.$echarts.init(this.$refs.deviceStatusPie);
            pieChart.setOption({
                title: {
                    text: '设备故障分析扇形图',
                    left: 'left'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    bottom: 'bottom'
                },
                series: [
                    {
                        name: '设备数量',
                        type: 'pie',
                        radius: '50%',
                        data: [
                            { value: 10, name: '故障 ' },
                            { value: 7, name: '演练' },
                            { value: 0, name: '测试' },
                            { value: 5, name: '误报' }
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });

            // 绘制设备状态柱状图
            let catChart = this.$echarts.init(this.$refs.deviceStatusCat);
            catChart.setOption({
                title: {
                    text: '设备故障分析柱状图',
                    left: 'left'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    orient: 'vertical',
                    bottom: 'bottom'
                },
                xAxis: {
                    type: 'category',
                    data: ['故障', '演练', '误报', '测试']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '次数',
                        data: [
                            {
                                value: 10,
                                itemStyle: {
                                    color: '#5470c6'
                                }
                            },
                            {
                                value: 7,
                                itemStyle: {
                                    color: '#91cc75'
                                }
                            },
                            {
                                value: 0,
                                itemStyle: {
                                    color: '#fac858'
                                }
                            },
                            {
                                value: 5,
                                itemStyle: {
                                    color: '#ee6666'
                                }
                            }
                        ],
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        }
                    }
                ]
            });
        }, 10);
    },
    created() {},
    methods: {}
};
</script>

<style lang="less" scoped>
.lineS {
    width: 100%;
    height: 300px;
}
.botCharts {
    margin-top: 20px;
    width: 100%;
    height: 400px;
    display: flex;
}
.leftS {
    width: 40%;
    height: 400px;
}
.rightS {
    width: 60%;
    height: 400px;
}
.dataPicker {
    display: flex;
    font-size: 0.5rem;
    align-items: center;
    height: 1rem;
    .btn1 {
        margin-left: 20px;
    }
}
.elTable {
    margin-top: 20px;
}
</style>


